import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../common/redux/hooks";
import { loadContractThunk } from "../../../common/redux/thunks/contract/load-contract-thunk";
import { EditContractForm } from "./EditContractForm";

export const EditContract = ({ embedded = false }: { embedded?: boolean }) => {
  const { contractId } = useParams();
  const dispatch = useAppDispatch();
  const contractState = useAppSelector((state) => state.contract.state);
  const { t } = useTranslation();

  useEffect(() => {
    if (!contractId) return;
    dispatch(loadContractThunk({ contractId }));
  }, [contractId, dispatch]);

  if (!contractId) {
    return <div>{t("404 not found")}</div>;
  }

  if (contractState?.id !== contractId) {
    return <div>{t("Loading")}...</div>;
  }

  return <EditContractForm embedded={embedded} />;
};
